import { Box } from '@mui/joy'
import { styled } from '@mui/joy/styles'

export const Divider = styled(Box)(() => ({
    width: '100%',
    height: '1px',
    backgroundColor: 'rgba(128, 128, 128, 0.15)',
}))
